export const PKG_NAME = "__PACKAGE_NAME__";
export const PKG_VERSION = "__PACKAGE_VERSION__";
export const BUILD_VERSION = "__BUILD_VERSION__";
